import { Grid } from 'react-loader-spinner';
import { useTheme } from 'styled-components';

import { SplashProps } from '../../../types';
import { Wrapper } from '../../Typhography/SplashStyle';

const Splash = ({ height, width, color, position, margin, wrapperStyle }: SplashProps) => {
  const theme = useTheme();

  return (
    <Wrapper position={position} style={wrapperStyle}>
      <div style={{ margin: margin }}>
        <Grid
          height={height ? height : 50}
          width={width ? width : 50}
          ariaLabel="loading-indicator"
          color={color ? color : theme.colors.purple}
        />
      </div>
    </Wrapper>
  );
};

export default Splash;
